import styled from 'styled-components';
import Text from './Text';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';

const Container = styled.div`
  width: auto;
  height: 36px;
  background-color: ${({ theme }) => theme.colors.neutral[100]};
  border: 1px solid ${({ $isActive, theme }) => ($isActive ? theme.colors.primary : theme.colors.neutral[400])};
  border-radius: 20px;
  padding: 8px 12px;
  border-radius: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

const ClearButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
`;

const ClearIcon = styled(ClearRoundedIcon)`
  color: ${(props) => props.theme.colors.text.alternative};
`;

const RemovableChip = ({ label, $isActive, onSelect, onRemove }) => {
  return (
    <Container $isActive={$isActive} onClick={onSelect}>
      <Text variant="body2">{label}</Text>
      <ClearButton
        onClick={(e) => {
          e.stopPropagation(); // Container 클릭 방지
          onRemove();
        }}
      >
        <ClearIcon sx={{ fontSize: 20 }}/>
      </ClearButton>
    </Container>
  );
};

export default RemovableChip;